import moment from 'moment'

export default class AccountNumbersDomain {
	/**
	 * Handles the default constructor
	 * @param {string} otherType - account type
	 * @param {string} otherSupplier - supplier
	 * @param {number} otherAccountNumber - account number
	 * @param {number} id - id
	 * @param {boolean} isCreate - in create mode
	 * @param {boolean} isUpdate - in update mode
	 * @param {boolean} isDelete - in delete mode
	 * @param {boolean} isBillToPreference - is this from the bill-to account
	 * @param {boolean} isReadOnly - is this object readOnly
	 * @param {string} createdAt - created date
	 * @param {string} updatedAt - updated date
	 * @returns {AccountNumbersDomain} - returns the new AccountNumbersDomain object
	 */
	constructor(otherType, otherSupplier, otherAccountNumber, id, isBillToPreference, isReadOnly, createdAt, updatedAt) {
		this.otherType = otherType 
		this.otherSupplier = otherSupplier 
		this.otherAccountNumber = otherAccountNumber 
		this.id = id 
		this.isCreate = false
		this.isUpdate = false
		this.isDelete = false
		this.isBillToPreference = isBillToPreference
		this.isReadOnly = isReadOnly
		this.createdAt = moment(createdAt)
		this.updatedAt = moment(updatedAt)
	}
}


// WEBPACK FOOTER //
// ./src/domains/AccountNumbersDomain.js